import React, { useState, useEffect } from 'react';
import { X, Gift, Zap } from 'lucide-react';

const WelcomePopupEN = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem('welcomePopupSeenEN');
    if (!hasSeenPopup) {
      setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('welcomePopupSeenEN', 'true');
      }, 1000);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fadeIn">
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={handleClose}
      ></div>

      <div className="relative bg-gradient-to-br from-gray-900 to-black border-2 border-red-600 rounded-2xl shadow-2xl max-w-md w-full animate-scaleIn overflow-hidden">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors z-10"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 via-transparent to-red-600/20 opacity-50"></div>

        <div className="relative p-8 text-center">
          <div className="mb-6 flex justify-center">
            <img 
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/3s7e8l1h_logodas.png"
              alt="Cloud Cheats"
              className="h-24 w-auto drop-shadow-2xl"
            />
          </div>

          <div className="inline-flex items-center bg-red-600/20 border border-red-600 rounded-full px-4 py-2 mb-4">
            <Gift className="w-5 h-5 text-red-500 mr-2" />
            <span className="text-red-500 font-bold text-sm">WELCOME!</span>
          </div>

          <h2 className="text-3xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            CLOUD CHEATS
          </h2>

          <div className="bg-gradient-to-r from-red-600/10 to-orange-600/10 border border-red-600/30 rounded-xl p-6 mb-6">
            <div className="flex items-center justify-center mb-3">
              <Zap className="w-6 h-6 text-yellow-500 mr-2" />
              <h3 className="text-xl font-bold text-white">Exclusive Deals!</h3>
            </div>
            <p className="text-gray-300 text-base leading-relaxed">
              Check out our <span className="text-red-500 font-bold">special promotions</span> and 
              <span className="text-green-400 font-bold"> improve your aim</span> in Free Fire!
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3 mb-6">
            <div className="bg-gray-800/50 rounded-lg p-3 border border-gray-700">
              <p className="text-red-500 font-bold text-2xl">-38%</p>
              <p className="text-gray-400 text-xs">Mobile</p>
            </div>
            <div className="bg-gray-800/50 rounded-lg p-3 border border-gray-700">
              <p className="text-red-500 font-bold text-2xl">-30%</p>
              <p className="text-gray-400 text-xs">Emulator</p>
            </div>
            <div className="bg-gray-800/50 rounded-lg p-3 border border-gray-700">
              <p className="text-green-500 font-bold text-xl">24/7</p>
              <p className="text-gray-400 text-xs">Support</p>
            </div>
          </div>

          <button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-red-600/50"
          >
            VIEW PRODUCTS
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopupEN;
